const asObj = (v) => v && typeof v === 'object' && !Array.isArray(v) ? v : {};
const str = (v) => (typeof v === 'string' ? v.trim() : '');
/**
 * Read the Supervision setting from a stored Provider Profile. A profile saved before the
 * toggle existed (no `cosignRequired` key) reads the way the Provider Profile page shows it:
 * on for a pre-licensed associate, with their billing supervisor as co-signer. The user's
 * org-chart supervisor is the last fallback for the co-signer.
 */
export function supervisionFrom(profile, orgChartSupervisorId) {
    const p = asObj(profile);
    const legacy = typeof p.cosignRequired !== 'boolean';
    const required = legacy ? p.kind === 'associate' : p.cosignRequired;
    const supervisorId = str(p.cosignerId) || (legacy ? str(p.supervisorId) : '') || orgChartSupervisorId || null;
    return { required, supervisorId };
}
/**
 * ehr#320 - Users & Profile → Supervisor shows a user's supervisor only while Supervision is on
 * ('' = none: their own signature finishes their notes).
 */
export function supervisorShown(s) {
    return s.required ? (s.supervisorId ?? '') : '';
}
/** A pre-licensed associate can't co-sign (Provider Profile's co-signer list leaves them out). */
export const isAssociateProfile = (profile) => asObj(profile).kind === 'associate';
/** "<eventId>@<YYYY-MM-DD>" → its parts (null when it isn't an appointment key). */
export function appointmentKeyParts(key) {
    const k = key ?? '';
    const at = k.lastIndexOf('@');
    if (at <= 0)
        return null;
    const eventId = k.slice(0, at);
    const dateKey = k.slice(at + 1);
    return /^\d{4}-\d{2}-\d{2}$/.test(dateKey) ? { eventId, dateKey } : null;
}
//# sourceMappingURL=supervision.js.map